import { z } from "zod";

export const sendEmailPayloadSchema = z.object({
  account: z.string(),
  q: z.string(),
});

export type SendEmailPayloadType = z.infer<typeof sendEmailPayloadSchema>;
